import { WixConnect } from 'widget/player-widget/utils/wix-connect';

import styles from './scrollbar-wrapper.styl';


@WixConnect(styles)
export default class ScrollbarWrapper extends React.Component {

  static propTypes = {
    children: React.PropTypes.any,
    className: React.PropTypes.string,
  };

  render() {
    const { className, children } = this.props;

    return (
      <div styleName="scrollbar-wrapper"
           className={className}>
        {children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/scrollbar-wrapper/scrollbar-wrapper.js